<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    right1Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.right1Data);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(right1Data) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    const cols = ['#3BDBDB', '#6CEBEB', '#C2FFFF', '#FFFFFF']

  const legendType = 'right'
    this.state.chart.setOption({
        grid: {
          containLabel: true,
          bottom: '2%',
          top: '30%',
          right: '5%',
          left:'10%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
           formatter: function(params) {//自定义划过显示样式
               return params[0].name+"<br>"+params[0].marker+params[0].seriesName+"："+params[0].data+"人"+"<br>"+
              params[1].marker+params[1].seriesName+"："+params[1].data+"%";
            },
        },
        legend: {
          orient: 'horizontal',
          top: '10%',
          right: '2%',
          data: ['就业人数', '就业率'],
          itemWidth: 20,
          itemHeight: 11,
          itemGap: 40,
          icon: "rect",
          textStyle: {
            fontSize: 12,
            color: '#fff',
            padding: [5, 0, 0, 2],
            rich: {
                    a: {
                      verticalAlign: 'middle',
                    },
                },
          },
          
        },
        xAxis: {
          triggerEvent: true,
          data: ['2019', '2020', '2021','2022', '2023', '2024'],
          axisLabel: {
            show: true,
            fontSize: 12,
            color: '#fff',
            align: 'center',
            verticalAlign: 'top',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#0B3561',
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: [
          {
            axisLabel: {
              interval: 0,
              show: false,
              fontSize: 12,
              color: '#0B3561',
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            
            splitLine: {
              show:false,
              lineStyle: {
                type: 'solid',
                color: '#0B3561',
                fontSize:12
              },
            },
          },
        ],
        series: [
          {
            name: '就业人数',
            type: 'bar',
            value:"人",
            barWidth: 15,
            silent: true,
            itemStyle: {
              normal: {
                color: '#286FFC',
                fontSize:12
              },
            },
            data: [120, 75, 90,120, 75, 90],
          },
          {
            name: '就业率',
            value:"%",
            type: 'bar',
            barWidth: 15,
            silent: true,
            itemStyle: {
              normal: {
                color: '#3BEC99',
              },
            },
            data: [100, 30, 75,90, 100, 75],
          },
        ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
